(function () {
  'use strict';

  /* ── Copy link button ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-copy]');
    if (!btn) return;
    navigator.clipboard.writeText(window.location.href).then(function () {
      var prev = btn.innerHTML;
      btn.textContent = 'Copied!';
      btn.classList.add('ka__share-btn--copied');
      setTimeout(function () {
        btn.innerHTML = prev;
        btn.classList.remove('ka__share-btn--copied');
      }, 2000);
    }).catch(function () {});
  });

  /* ── Rich text heading enhancement ── */
  var content = document.querySelector('[data-article-content]');
  if (!content) return;

  var NUMBERED_RE = /^(\d+)[.\s]/;

  function makeBadge(cls, num) {
    var span = document.createElement('span');
    span.className = cls;
    span.setAttribute('aria-hidden', 'true');
    span.textContent = num;
    return span;
  }

  function makeExtLinkIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'ka__ext-link-icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.innerHTML = '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>';
    return svg;
  }

  /* H2 - numbered: badge; standard: blue left accent bar (CSS handles it) */
  content.querySelectorAll('h2').forEach(function (h2) {
    var text = h2.textContent.trim();
    var match = NUMBERED_RE.exec(text);
    if (match) {
      var num = match[1];
      var rest = text.replace(NUMBERED_RE, '').trim();
      h2.textContent = '';
      h2.classList.add('has-badge');
      var badge = makeBadge('ka__h2-badge', num);
      var textSpan = document.createElement('span');
      textSpan.textContent = rest;
      h2.appendChild(badge);
      h2.appendChild(textSpan);
    }
  });

  /* H3 - numbered: yellow badge; standard: yellow left border (CSS handles it) */
  content.querySelectorAll('h3').forEach(function (h3) {
    var text = h3.textContent.trim();
    var match = NUMBERED_RE.exec(text);
    if (match) {
      var num = match[1];
      var rest = text.replace(NUMBERED_RE, '').trim();
      h3.textContent = '';
      h3.classList.add('has-badge');
      var badge = makeBadge('ka__h3-badge', num);
      var textSpan = document.createElement('span');
      textSpan.className = 'ka__h3-text';
      textSpan.textContent = rest;
      h3.appendChild(badge);
      h3.appendChild(textSpan);
    }
  });

  /* H6 and heading links - append external-link icon to any <a> inside h6 (or any heading) */
  content.querySelectorAll('h6 a, h1 a, h2 a, h3 a, h4 a, h5 a').forEach(function (a) {
    a.appendChild(makeExtLinkIcon());
  });

  /* ATC forms - AJAX add to cart for featured + tagged product cards */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ka__feat-atc-form, .ka__tagged-atc-form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.ka__feat-atc-btn, .ka__tagged-atc-btn');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = 'Adding…';

    /* Route through KitstersCart (assets/kitsters-cart-bridge.js) so Dawn's
       <cart-drawer> re-renders and opens. This used to POST the raw FormData
       and then dispatch `cart:refresh` -- an event NOTHING in this tree listens
       for, so the drawer kept its page-load HTML and the item only showed up
       after a page refresh. The bridge posts JSON, so the form is flattened
       here: id + quantity + any properties[...] a card carries. */
    var fd = new FormData(form);
    var payload = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && String(value).trim() !== '') {
        payload.properties = payload.properties || {};
        payload.properties[m[1]] = value;
      }
    });

    window.KitstersCart.addToCart(payload)
      .then(function (item) {
        if (item && (item.id || (item.items && item.items.length))) {
          btn.textContent = 'Added ✓';
          btn.style.background = '#388e3c';
          setTimeout(function () {
            btn.textContent = origText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        } else {
          btn.textContent = 'Error';
          setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
        }
      })
      .catch(function () {
        btn.textContent = origText;
        btn.disabled = false;
      });
  });

})();

/* ── Synchronized column scroll (desktop ≥1024px) ──
   Owner call 2026-07-27: the left and right columns should scroll in sync.
   Mirrors the PDP implementation (kitsters-product.js, #668).

   One column always runs out before the other, so under plain flow it leaves a
   tall dead gap beside the longer one; under the `position: sticky` this
   replaces, the sidebar pinned at the top and anything in it past the fold
   became unreachable. Translating the SHORT column down in proportion to page
   scroll fixes both: it drifts at a fraction of the page's rate, so all of it
   passes through the viewport, and its bottom lands on the container's bottom
   exactly as the container bottom reaches the viewport bottom - both columns
   finish together.

     D = containerHeight - shortColumnHeight    // travel the short column owes
     S = containerHeight - usableViewportHeight // page scroll available to spend
     s = distance scrolled past the pin line, clamped to [0, S]
     y = D * (s / S)

   ⚠️ EITHER column can be the short one, and getting this wrong is why the
   first attempt (#684) looked like it did nothing. It only ever moved the
   sidebar, so it bailed out (D <= 0) whenever the sidebar was the TALLER
   column - and this sidebar is a near-constant ~1800px (product card + 5
   popular posts + newsletter + categories) whatever the post, so every article
   with less than ~1800px of body got no sync at all. Short posts are common.
   The short column is therefore picked from live layout on every frame and
   re-picked after a resize, because a reflow can flip which one it is; the
   class is cleared off the other column whenever it changes hands.

   Every input is re-read from layout on each frame (never cached across
   resizes), and a ResizeObserver re-runs it when either column changes height
   - late-loading images alone move D by hundreds of pixels. Bails out when the
   container already fits the viewport (S <= 0), when the columns are the same
   height (D <= 0), when the grid has collapsed to one column (≤1023px, where
   the sidebar becomes a static 2-up grid below the article), and under
   prefers-reduced-motion.

   A column taller than the usable viewport cannot be fully on screen at any
   one moment, so its top tucks above the header near the end. That is inherent
   to a column that does not fit, and is still strictly better than the sticky
   it replaces, which never revealed the sidebar's lower half at all.

   NOTE: the transformed column becomes a containing block for fixed-position
   descendants. Neither column has any today - the newsletter form, lists,
   cards and article body are all in-flow - but note that when the short column
   is .ka__main, that body is owner-authored rich text; a `position: fixed`
   embed pasted into a post would be affected. ── */
(function () {
  'use strict';

  var container = document.querySelector('.ka__layout');
  var main = container ? container.querySelector('.ka__main') : null;
  var sidebar = container ? container.querySelector('.ka__sidebar') : null;
  if (!container || !main || !sidebar) return;

  // Matches the clearance the previous `position: sticky; top: 100px` used.
  var PIN_TOP = 100;
  var SYNC_CLASS = 'ka__col--sync';

  var desktop = window.matchMedia('(min-width: 1024px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var synced = null;          // the column currently being translated, if any
  var ticking = false;

  function release(col) {
    if (!col) return;
    col.classList.remove(SYNC_CLASS);
    col.style.removeProperty('--ka-sync-y');
  }

  function clear() {
    if (!synced) return;
    release(synced);
    synced = null;
  }

  function update() {
    ticking = false;
    if (!desktop.matches || calm.matches) return clear();

    // Grid collapsed to one column - offsetTop is a layout value, so the
    // transform on a column cannot skew this check.
    if (Math.abs(sidebar.offsetTop - main.offsetTop) > 4) return clear();

    // Whichever column is shorter is the one that owes travel. Re-read every
    // frame: a resize (or a late image) can hand this over to the other side.
    var short = main.offsetHeight <= sidebar.offsetHeight ? main : sidebar;

    var containerH = container.offsetHeight;
    var travel = containerH - short.offsetHeight;
    var scrollRange = containerH - (window.innerHeight - PIN_TOP);
    if (travel <= 0 || scrollRange <= 0) return clear();

    // container is never transformed, so its rect is its true scroll position.
    var scrolled = PIN_TOP - container.getBoundingClientRect().top;
    if (scrolled < 0) scrolled = 0;
    else if (scrolled > scrollRange) scrolled = scrollRange;

    if (synced !== short) {
      release(synced);          // hand-over: never leave both columns offset
      short.classList.add(SYNC_CLASS);
      synced = short;
    }
    short.style.setProperty('--ka-sync-y', (travel * (scrolled / scrollRange)).toFixed(1) + 'px');
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  window.addEventListener('load', request);

  if (window.ResizeObserver) {
    // Both columns, not just one - which of them is the short one can change.
    var ro = new ResizeObserver(request);
    ro.observe(container);
    ro.observe(main);
    ro.observe(sidebar);
  }

  // matchMedia change events keep the bail-outs honest without waiting for a
  // scroll or resize (reduced-motion can flip mid-session).
  if (desktop.addEventListener) {
    desktop.addEventListener('change', request);
    calm.addEventListener('change', request);
  }

  update();
})();
